import styled from "styled-components";
import { useTranslation } from "react-i18next";
import Icon from "../../Icon/Icon";
import { TickSolid } from "../../../assets/icons";

const StyledButton = styled.button`
  padding: 8px 12px;
  border: 2px solid #202227;
  background-color: #ffffff;
  color: #202227;
  cursor: pointer;
  display: flex;
  align-items: center;
  border-radius: 4px;
  font-size: 1em;
  transition: border-color 0.25s;
  font-weight: 500;
  font-family: inherit;

  &:focus {
    outline: 2px solid black;
  }
`;

const StyledIcon = styled(Icon)`
  margin-right: 5px;
`;

export type PromotionSelectButtonProps = {
  isSelected: boolean;
  onClick: (isSelected: boolean) => void;
  dataId?: string;
  ariaLabel?: string;
};

export const PromotionSelectButton: React.FC<PromotionSelectButtonProps> = ({
  isSelected,
  onClick,
  dataId,
  ariaLabel,
}) => {
  const { t } = useTranslation();
  return (
    <StyledButton
      onClick={() => onClick(!isSelected)}
      data-id={dataId}
      aria-label={ariaLabel}
    >
      {isSelected && <StyledIcon icon={TickSolid} />}
      {isSelected ? t("Selected") : t("Select")}
    </StyledButton>
  );
};

export default PromotionSelectButton;
